module.exports = __webpack_public_path__ + "img/darkblue_online.9d0ba9c2.png";